import React from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import { useNavigate } from "react-router-dom";
import ImageUpload from "./ImageUpload";

function UpdateImage() {
  const navigation = useNavigate();

  return (
    <AppContainer title="Upload Pole Images">
      <div className="card custom-card main-content-body-profile">
        <div className="card-body tab-content h-100">
          <h4 className="card-title">Update pole Images</h4>

          <ImageUpload navi={navigation} />
        </div>
      </div>
    </AppContainer>
  );
}

export default UpdateImage;
